import { FeatureAccess } from '@/lib/sdk/organization/types';

// Dashboard path of each feature that has a page. ai_chat has none, and master_data's
// path differs from its key, so redirecting to a raw feature key can land on no route.
const FEATURE_PATHS: Partial<Record<FeatureAccess, string>> = {
  reports: 'reports',
  team: 'team',
  workflows: 'workflows',
  master_data: 'master-data',
  nudges: 'nudges',
};

/** The dashboard path of a feature, or null if it has no page. */
export function featurePath(feature: string): string | null {
  return FEATURE_PATHS[feature as FeatureAccess] ?? null;
}

/** The path of the first feature that has a dashboard page, or null if none does. */
export function firstFeaturePath(features: readonly string[]): string | null {
  for (const feature of features) {
    const path = featurePath(feature);
    if (path) return path;
  }
  return null;
}
